<template>
  <van-popup class="popup" v-model="show" round position="bottom">
    <div class="popup-title">
      <span>验收报警</span>
    </div>
    <div class="popup-content">
      <div class="aj-form-item form-item-flex">
        <div class="aj-form-label">验收意见</div>
        <div class="aj-form-content">
          <textarea maxlength="100" v-model="handleOpinion" class="input-width-full" placeholder-style="color:#C4C4C4" placeholder="请填写" rows="5" />
        </div>
      </div>
    </div>
    <div class="pop-bottom" style="display: flex; justify-content: space-around">
      <div class="bottom-button" @click.stop="cancel()">取 消</div>
      <div class="bottom-button button-primary" @click.stop="confirm()">确 定</div>
    </div>
  </van-popup>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import * as constant from '@/constant';
export default {
  props: {
    handlerId: {
      type: String,
      default: null
    },
    handlerName: {
      type: String,
      default: null
    },
    schoolId: {
      type: String,
      default: null
    },
    token: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      show: false,
      handleOpinion: '',
      ids: [],
      examineResult: null
    };
  },

  methods: {
    open(ids, examineResult) {
      this.ids = ids;
      this.show = true;
      this.examineResult = examineResult;
    },
    cancel() {
      this.resetAll();
      this.show = false;
    },
    confirm() {
      let obj = {
        ids: this.ids,
        handleOpinion: this.handleOpinion,
        userId: this.handlerId,
        schoolId: this.schoolId,
        examineResult: this.examineResult
      };
      //   console.log(obj);
      //   return;

      const loading = this.$toast.loading({
        duration: 0,
        message: '加载中',
        forbidClick: true,
        getContainer: '#app'
      });
      axios
        .post(constant.baseUrl + 'student-consumer/api/schoolBus/approvalWarningMini', obj, {
          headers: {
            Authorization: this.token
          }
        })
        .then(res => {
          loading.clear();
          if (res.data.data) {
            this.$toast(res.data.data);
          } else {
            this.$toast(this.examineResult == 1 ? '验收成功' : '驳回成功');
          }
          setTimeout(() => {
            this.cancel();
            this.$emit('refresh');
          }, 1500);
        })
        .catch(e => {
          this.$toast('操作失败，请重试');
        });
    },
    resetAll() {
      this.handleOpinion = '';
      this.ids = [];
      this.examineResult = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.popup {
  font-size: 0.78rem;
}

.popup-title {
  padding: 1.1rem 0 0.8rem 0;
  text-align: center;
  font-size: 0.87rem;
  font-weight: bold;
}

.aj-form-item {
  padding: 1.22rem 0;
  font-size: 0.78rem;

  .required {
    color: #ff4747;
  }

  .aj-form-label {
    color: #1a1a1a;
  }
}

.aj-form-item.no-padding {
  padding: 0;
}

.aj-form-content {
  color: #666;

  textarea {
    border: none;
  }
}

.aj-form-item + .aj-form-item {
  border-top: 0.06rem solid #f4f4f6;
}

.form-item-flex {
  display: flex;
  justify-content: space-between;

  .aj-form-label {
    flex-shrink: 0;
    // line-height: 1.5;
    // line-height: 44rpx;
  }

  .aj-form-content {
    flex: 1;
    // line-height: 1.5;
    padding-left: 1.4rem;
  }
}

.align-center {
  align-items: center;
}

.input-width-full {
  width: 100%;
}

.input-width-full + .input-width-full {
  margin-top: 1.2rem;
}

.result-tag + .result-tag {
  margin-left: 0.67rem;
}

.result-tag {
  display: inline-block;
  border-radius: 0.22rem;
  font-size: 0.67rem;
  padding: 0.28rem 0.94rem;

  &.zhenshi {
    background-color: rgba($color: #f16f6d, $alpha: 0.15);
    color: #f16f6d;

    &.active {
      background: #f16f6d;
      color: #fff;
    }
  }

  &.xunjian {
    background-color: rgba($color: #fea301, $alpha: 0.15);
    color: #fea301;

    &.active {
      background: #fea301;
      color: #fff;
    }
  }

  &.wubao {
    background-color: rgba($color: #8f939e, $alpha: 0.15);
    color: #8f939e;

    &.active {
      background: #8f939e;
      color: #fff;
    }
  }
}

.photo-box {
  width: 33%;
  line-height: 1;

  .photo-item {
    position: relative;
    display: inline-block;
    width: 6.5rem;
    height: 6.5rem;
    background-color: #f1f2f6;
    border-radius: 0.22rem;

    img {
      object-fit: cover;
    }

    .photo-del {
      position: absolute;
      right: -0.5rem;
      top: -0.5rem;
    }
  }

  ::v-deep.van-uploader__upload {
    margin: 0;
    width: 6.5rem;
    height: 6.5rem;
  }
}

.photo-box:nth-of-type(3),
.photo-box:nth-of-type(6) {
  text-align: right;
}

.photo-box:nth-of-type(2),
.photo-box:nth-of-type(5) {
  text-align: center;
}

.photo-content {
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 0;
}

.bottom-button {
  background-color: #f1f2f6;
  display: inline-block;
  border-radius: 0.22rem;
  font-size: 0.78rem;
  padding: 0.72rem 0;
  flex: 1;
  text-align: center;
  margin: 0 0.5rem;
}

.button-disabled {
  opacity: 0.5;
}

.button-primary {
  background-color: #0065e1;
  color: #fff;
}

.button-warning {
  background-color: #fea301;
  color: #fff;
}

.button-danger {
  background-color: #f16f6d;
  color: #fff;
}

.button-info {
  background-color: #8f939e;
  color: #fff;
}

.pop-bottom {
  padding: 0.83rem 0;
}
</style>
